import React, { useEffect, useMemo, useState } from "react";
import {
  Link,
  useSearchParams,
  useNavigate,
  useLocation,
} from "react-router-dom";
import axios from "axios";
import { FiPlus } from "../../assets/icons/vander";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import ScrollToTop from "../../components/scroll-to-top";
import toast from "react-hot-toast";
import fallbackImage from "../../assets/images/categories/football.jpg";

// Custom SVG components for icons
const AlertCircle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-exclamation-circle text-red-500"
    viewBox="0 0 16 16"
  >
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
    <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
  </svg>
);

const CheckCircle2 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-check-circle-fill text-green-500"
    viewBox="0 0 16 16"
  >
    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
  </svg>
);

const Edit = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-pencil text-gray-600 hover:text-green-500"
    viewBox="0 0 16 16"
  >
    <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
  </svg>
);

const Trash2 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-trash text-gray-600 hover:text-green-500"
    viewBox="0 0 16 16"
  >
    <path d="M5.5 5.5A.5.5 0 0 1 6 5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5zm2.5 3a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z" />
    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
  </svg>
);

// Payment method icons
const CODIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2z" />
  </svg>
);

const PhonePeIcon = () => (
  <svg width="32" height="30" viewBox="0 0 333334 199007" xmlns="http://www.w3.org/2000/svg">
    <path d="M44732 130924h1856l-1738 7215c-265 1061-206 1885 147 2415 354 530 1001 795 1973 795 942 0 1737-265 2356-795 618-531 1031-1355 1296-2415l1737-7215h1885l-1767 7392c-383 1590-1060 2798-2061 3593-972 795-2268 1208-3858 1208s-2680-383-3269-1179c-589-795-707-2002-324-3592l1767-7421zm223507 11868l2826-11868h6449l-383 1649h-4564l-706 2974h4564l-413 1679h-4564l-913 3827h4565l-412 1738h-6449zm-177-8982c-413-470-913-824-1443-1031-531-235-1119-353-1797-353-1266 0-2385 412-3386 1237s-1649 1915-1973 3239c-295 1267-177 2327 413 3181 559 824 1442 1237 2620 1237 677 0 1355-118 2031-383 678-235 1356-619 2062-1119l-530 2179c-589 382-1207 648-1856 825-648 176-1296 265-2002 265-883 0-1679-148-2356-443-678-294-1236-736-1679-1324-441-560-706-1237-824-2002-117-766-88-1590 148-2474 206-883 559-1680 1031-2445 471-766 1089-1443 1796-2002 706-589 1472-1030 2297-1325 824-294 1648-441 2503-441 677 0 1295 88 1885 294 559 207 1089 500 1560 913l-500 1972zm-18317 4300h3209l-530-2710c-29-176-59-383-59-589-30-235-30-471-30-736-118 265-235 500-383 736-118 235-235 442-353 619l-1855 2680zm4093 4682l-589-3062h-4594l-2062 3062h-1972l8539-12338 2650 12338h-1972zm-15548 0l2827-11868h6449l-383 1649h-4565l-706 2945h4563l-412 1679h-4564l-1325 5565h-1885v30zm-5566-6832h353c1001 0 1679-118 2062-354 382-236 648-648 795-1267 146-648 88-1119-207-1384-293-265-913-413-1855-413h-354l-795 3417zm-471 1502l-1267 5300h-1767l2828-11867h2621c766 0 1354 59 1737 148 411 89 736 265 971 500 295 295 471 648 559 1119 89 443 59 943-59 1502-235 943-619 1709-1207 2238-589 530-1326 854-2209 972l2680 5387h-2121l-2562-5300h-206zm-11632 5330l2828-11868h6478l-382 1649h-4565l-706 2974h4564l-411 1679h-4565l-912 3827h4564l-413 1738h-6479zm-2031-10248l-2444 10218h-1884l2444-10218h-3063l383-1649h8010l-382 1649h-3063zm-19170 10248l2945-12338 5595 7244c148 206 294 413 441 648s295 501 471 794l1974-8216h1737l-2945 12310-5713-7392c-147-206-295-412-441-619-147-235-265-442-354-707l-1972 8245h-1737v30zm-4594 0l2827-11868h1884l-2827 11868h-1884zm-13870-2385l1678-707c29 530 176 942 501 1207 324 265 765 413 1354 413 559 0 1031-148 1443-471 412-324 678-736 795-1266 177-707-235-1326-1236-1855-147-89-235-148-325-177-1119-648-1825-1207-2120-1737-294-530-354-1149-176-1884 235-972 736-1738 1530-2356 796-589 1679-913 2740-913 854 0 1530 177 2031 500 501 325 766 825 854 1444l-1648 766c-148-383-325-648-560-825-235-176-530-265-884-265-501 0-942 147-1295 412-354 265-589 619-707 1090-176 707 325 1383 1472 2002 89 59 147 89 207 117 1001 530 1678 1061 1972 1591 295 529 354 1148 178 1943-266 1119-825 2002-1680 2680-853 647-1855 1002-3033 1002-971 0-1737-237-2267-708-589-471-854-1149-824-2002zm-1973-7863l-2444 10218h-1884l2444-10218h-3062l381-1649h8010l-383 1649h-3062zm-19170 10248l2944-12338 5596 7244c147 206 295 413 442 648 147 235 294 501 471 794l1973-8216h1737l-2944 12310-5713-7392c-148-206-294-412-442-619-147-235-265-442-353-707l-1973 8245h-1737v30zm-8599 0l2827-11868h6449l-383 1649h-4564l-707 2974h4564l-412 1679h-4564l-913 3827h4565l-413 1738h-6449zm-3121-5860c0-88 29-354 88-766 30-353 59-618 89-854-118 266-236 530-383 824-147 266-324 560-530 825l-4535 6331-1472-6448c-59-265-118-530-148-766-29-235-59-500-59-736-59 236-147 500-235 794-89 266-206 560-354 855l-2650 5831h-1737l5683-12368 1620 7479c29 118 59 324 89 589 29 266 88 619 147 1031 206-353 471-765 825-1296 88-146 176-235 206-324l5124-7479-177 12368h-1737l148-5890zm-17933 5860l1296-5418-2356-6420h1972l1472 4035c30 117 59 235 118 411 59 178 89 354 147 530 118-176 236-353 354-530 118-176 236-324 353-471l3446-3975h1884l-5506 6390-1296 5417h-1885v30zm-8746-4682h3209l-530-2710c-30-176-59-383-59-589-30-235-30-471-30-736-118 265-236 500-383 736-118 235-235 442-354 619l-1855 2680zm4063 4682l-589-3062h-4594l-2061 3062h-1973l8540-12338 2650 12338h-1973zm-11808-6920h471c1031 0 1767-118 2179-354 412-235 677-648 825-1237 146-618 58-1089-236-1324-324-265-972-383-1943-383h-471l-825 3299zm-501 1590l-1266 5330h-1767l2827-11868h2856c854 0 1443 59 1826 147s678 236 913 471c294 265 500 648 589 1119 88 472 59 972-59 1531-147 560-353 1090-677 1561s-707 854-1119 1119c-353 206-736 382-1148 471-412 88-1060 148-1885 148h-1089v-30zm-17580 3563h1590c854 0 1531-59 2003-176 471-117 883-324 1266-589 530-383 972-854 1325-1443 354-560 619-1237 795-2002 176-766 235-1414 147-1972-88-561-294-1061-648-1444-265-294-589-471-1030-589-442-118-1119-176-2091-176h-1354l-2003 8392zm-2297 1767l2828-11868h2532c1649 0 2798 88 3415 265 619 177 1148 442 1561 854 530 530 884 1208 1031 2002 147 825 88 1767-147 2798-266 1060-648 1972-1178 2796-530 825-1207 1473-2002 2003-589 413-1237 678-1944 854-677 177-1708 265-3063 265h-3033v30zm-8628 0l2827-11868h6449l-383 1649h-4565l-707 2974h4565l-412 1679h-4565l-913 3827h4565l-412 1738h-6449zm-4565 0l2827-11868h1884l-2827 11868h-1885zm-8540 0l2827-11868h6449l-383 1649h-4564l-707 2945h4564l-412 1679h-4565l-1325 5565h-1885v30zm-4565 0l2827-11868h1884l-2827 11868h-1885zm-13015 0l2944-12338 5595 7244c147 206 294 413 442 648 147 235 294 501 471 794l1973-8216h1737l-2944 12310-5713-7392c-147-206-294-412-442-619-147-235-265-442-353-707l-1973 8245h-1737v30z" fill="#3a3734"/>
    <path d="M233961 120588h-12927l17963-64873h12927l-17963 64873zm-107424-4064c-707 2562-3063 4358-5713 4358H54185c-1826 0-3180-619-4064-1855-883-1238-1089-2769-559-4594l16255-58541h12928l-14518 52298h51710l14517-52298h12928l-16844 60632zm100710-58777c-883-1237-2268-1855-4152-1855h-71027l-3504 12721h64608l-3769 13576h-51680v-30h-12927l-10719 38724h12927l7185-25973h58100c1826 0 3534-619 5124-1855 1590-1237 2651-2768 3151-4594l7185-25972c559-1943 383-3504-501-4741z" fill="#716d6a"/>
    <path fill="#0e8635" d="M274245 55833l16344 32510-34365 32510 4087-14747 18794-17763-8941-17785z"/>
    <path fill="#e97208" d="M262762 55833l16343 32510-34395 32510z"/>
  </svg>
);

const UPIIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
  </svg>
);

const CardIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
  </svg>
);

const NetbankingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
  </svg>
);

export default function CheckOut() {
  const [loading, setLoading] = useState(false);
  const [deleveryAddress, setDeliveryAddress] = useState({});
  const [checkOutItems, setCheckoutItems] = useState([]);
  const [coupon, setCoupon] = useState("");
  const [openAdd, setOpenAdd] = useState(false);
  const [change, setChange] = useState(false);
  const [orderInitialized, setOrderInitialized] = useState(false);
  const [customizationData, setCustomizationData] = useState(null);
  const [appliedCouponData, setAppliedCouponData] = useState(null);
  const [isApplyCouponLoading, setIsApplyCouponLoading] = useState(false);
  const [isApplyCouponError, setIsApplyCouponError] = useState(false);
  const [userAddressData, setUserAddressData] = useState([]);
  const [addressFetchError, setAddressFetchError] = useState(null);
  const [newAddress, setNewAddress] = useState({
    full_name: "",
    mobile_number: "",
    care_of: "",
    address1: "",
    address2: "",
    landmark: "",
    pincode: "",
    city: "",
    district: "",
    state: "",
    country: "",
  });
  const [editAddress, setEditAddress] = useState(null);
  const [pincodeError, setPincodeError] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("COD");
  const [originalSelectedItems, setOriginalSelectedItems] = useState([]);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { state } = useLocation();
  const productId = searchParams.get("productId");
  const locationType = searchParams.get("locationType") || state?.locationType;
  const customizationId = searchParams.get("customizationId");
  const customerId = localStorage.getItem("customer_id");
  const BASE_MEDIA_URL = process.env.REACT_APP_MEDIA_BASE_URL;

  // Static user data
  const userData = {
    customer_id: localStorage.getItem("customer_id") || "6",
    name: "John Doe",
    email: "john@example.com",
  };

  // Static filtered item for single product checkout
  const filteredItems = {
    item_code_id: "item3",
    product_id: "prod3",
    product_name: "Unisex Hoodie",
    selling_price: 1299,
    mrp: 1999,
    category_id: "cat1",
    brand_id: "brand1",
    photos: [{ photo_url: "/images/product3.jpg" }],
    variants: [
      { variant_name: "Colour", code: "#000000" },
      { variant_name: "Size", code: "L" },
    ],
  };

  const count = 1; // Static count for single product

  // Static order item
  const [orderItem, setOrderItem] = useState({
    customer_id: userData.customer_id,
    items_code: [],
    shipping_address: "",
    payment_method: "COD",
    total_amount: 0,
  });

  // Static pincode availability (kept for UI)
  const pincodeAvailability = [
    { product_id: "P2", available: true, message: "Available for delivery" },
    { product_id: "P63", available: true, message: "Available for delivery" },
    { product_id: "prod3", available: true, message: "Available for delivery" },
  ];

  // === NEW: Collect product IDs to check availability ===
  const productIdsToCheck = useMemo(() => {
    if (locationType === "product" && filteredItems) {
      return [filteredItems.product_id];
    }

    if (locationType === "cart" && originalSelectedItems?.length) {
      return originalSelectedItems.map(i => i.product_id || i.item_id);
    }

    if (locationType === "customization" && customizationId) {
      return [customizationId];
    }

    return [];
  }, [locationType, filteredItems, originalSelectedItems, customizationId]);

  // === NEW: Check product availability API ===
const checkAvailability = async () => {
  if (!deleveryAddress?.pincode) {
    toast.error("Please select a delivery address first.");
    return false;
  }

  // 1. Regular products (is_product === true) → use /check-product-availability/
  const regularItems = originalSelectedItems.filter(
    (i) => i.is_product === true || i.is_product === "true"
  );
  const regularIds = regularItems
    .map((i) => i.product_id || i.item_id)
    .filter(Boolean);

  // 2. Custom products (is_product === false) → use /check-pincode/
  const customItems = originalSelectedItems.filter(
    (i) => i.is_product === false || i.is_product === "false"
  );

  try {
    // ---------- Regular products ----------
    if (regularIds.length > 0) {
      const base = `${process.env.REACT_APP_API_BASE_URL}/check-product-availability/`;
      const params = new URLSearchParams();
      params.append("pincode", deleveryAddress.pincode);
      regularIds.forEach((id) => params.append("product_id", id));

      const url = `${base}?${params.toString()}`;
      const res = await axios.get(url);
      const data = Array.isArray(res.data) ? res.data : [];

      const unavailable = data.filter((r) => !r.available);
      if (unavailable.length > 0) {
        const messages = unavailable
          .map((r) => `${r.product_id}: ${r.message || "Not available"}`)
          .join("\n");
        toast.error(`Delivery not available for regular product(s):\n${messages}`);
        return false;
      }
    }

    // ---------- Custom products ----------
    if (customItems.length > 0) {
      const pincodeUrl = `${process.env.REACT_APP_API_BASE_URL}/check-pincode/?pincode=${deleveryAddress.pincode}`;
      const pinRes = await axios.get(pincodeUrl);

      // Expected response: { available: true, message: "..." } or similar
      if (!pinRes.data?.available) {
        toast.error(
          pinRes.data?.message || "Delivery not available for customized product(s)."
        );
        return false;
      }
    }

    return true;
  } catch (err) {
    console.error("Availability check failed:", err);
    toast.error("Invalid Pincode, Use other address.");
    return false;
  }
};
  const fetchAddresses = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/address/?customer_id=${customerId}`
      );
      setUserAddressData(response.data);
      const defaultAddress = response.data.find((address) => address.default);
      setDeliveryAddress(defaultAddress || response.data[0] || {});
    } catch (error) {
      console.error("Error fetching addresses:", error);
      setAddressFetchError("Failed to load addresses. Please try again.");
      setUserAddressData([]);
    }
  };

  useEffect(() => {
    if (customerId) {
      fetchAddresses();
    }
  }, [customerId]);

  useEffect(() => {
    if (
      !userData.customer_id ||
      !deleveryAddress.address_id ||
      orderInitialized
    )
      return;

    const initializeOrder = async () => {
      if (locationType === "product" && filteredItems) {
        const orderData = [
          {
            item_code_id: filteredItems.item_code_id,
            quantity: count,
            price: filteredItems.selling_price || 0,
            product_id: filteredItems.product_id,
            category_id: filteredItems.category_id,
            brand_id: filteredItems.brand_id,
          },
        ];

        const totalAmount = orderData.reduce(
          (acc, item) => acc + item.quantity * item.price,
          0
        );

        setOrderItem({
          customer_id: userData.customer_id,
          items_code: orderData,
          shipping_address: deleveryAddress.address_id,
          payment_method: selectedPaymentMethod,
          total_amount: totalAmount,
        });

        setCheckoutItems([filteredItems]);
        setOrderInitialized(true);
      } else if (locationType === "cart" && state?.selectedItems) {
        const orderData = state.selectedItems.map((item) => {
          const variant = item.variant || {};
          const price =
            variant?.sizes?.[0]?.price?.discounted ||
            variant?.sizes?.[0]?.price?.mrp ||
            999;
          return {
            item_code_id: item.item_id,
            quantity: item.quantity || 1,
            price: price,
            product_id: item.product_id || item.item_id,
            category_id: item.category_id || "custom",
            brand_id: item.brand_id || "custom",
          };
        });

        const totalAmount = orderData.reduce(
          (acc, item) => acc + item.quantity * item.price,
          0
        );

        setOrderItem({
          customer_id: userData.customer_id,
          items_code: orderData,
          shipping_address: deleveryAddress.address_id,
          payment_method: selectedPaymentMethod,
          total_amount: totalAmount,
        });

        setOriginalSelectedItems(state.selectedItems);

        setCheckoutItems(
          state.selectedItems.map((item) => ({
            item_code_id: item.item_id,
            quantity: item.quantity || 1,
            item: {
              product_id: item.product_id || item.item_id,
              product_name: item.product_name,
              selling_price:
                item.variant?.sizes?.[0]?.price?.discounted ||
                item.variant?.sizes?.[0]?.price?.mrp ||
                999,
              mrp: item.variant?.sizes?.[0]?.price?.mrp || 999,
              photos: item.variant?.images
                ? [{ photo_url: `${BASE_MEDIA_URL}${item.variant.images[0]}` }]
                : item.reference_image
                ? [{ photo_url: `${BASE_MEDIA_URL}${item.reference_image}` }]
                : [{ photo_url: `${fallbackImage}` }],
              variants: [
                {
                  variant_name: "Colour",
                  code: item.variant?.color || item.custom_text || "N/A",
                },
                {
                  variant_name: "Size",
                  code:
                    item.custom_size || item.variant?.sizes?.[0]?.size || "N/A",
                },
              ],
            },
            isCustomized: !(
              item.is_product === true || item.is_product === "true"
            ),
            customizations: !(
              item.is_product === true || item.is_product === "true"
            )
              ? {
                  customText: item.custom_text || "None",
                  selectedColor: item.variant?.color || "Default",
                  selectedSize:
                    item.custom_size || item.variant?.sizes?.[0]?.size || "N/A",
                  logos: item.logos || [],
                }
              : null,
          }))
        );
        setOrderInitialized(true);
      } else if (locationType === "customization" && customizationId) {
        const customizationData = {
          item_code_id: customizationId,
          quantity: count,
          price: 999,
          product_id: customizationId,
          category_id: "custom",
          brand_id: "custom",
          isCustomized: true,
          customizations: {
            logos: [],
            customText: "Custom Text",
            selectedColor: "#ffffff",
            selectedSize: "M",
          },
        };

        setOrderItem({
          customer_id: userData.customer_id,
          items_code: [customizationData],
          shipping_address: deleveryAddress.address_id,
          payment_method: selectedPaymentMethod,
          total_amount: customizationData.price * customizationData.quantity,
        });

        setCheckoutItems([customizationData]);
        setCustomizationData(customizationData);
        setOrderInitialized(true);
      }
    };

    initializeOrder();
  }, [
    userData,
    deleveryAddress,
    locationType,
    filteredItems,
    state?.selectedItems,
    orderInitialized,
    customizationId,
    selectedPaymentMethod,
  ]);

  const handlePincodeChange = async (e) => {
    const pincode = e.target.value;
    setNewAddress({ ...newAddress, pincode });

    if (pincode.length === 6 && /^\d{6}$/.test(pincode)) {
      setPincodeError(null);
      try {
        const response = await fetch(
          `https://api.postalpincode.in/pincode/${pincode}`
        );
        const data = await response.json();

        if (data[0]?.Status === "Success" && data[0]?.PostOffice?.length > 0) {
          const postOffice = data[0].PostOffice[0];
          setNewAddress((prev) => ({
            ...prev,
            city: postOffice.Name,
            district: postOffice.District,
            state: postOffice.State,
            country: postOffice.Country,
          }));
        } else {
          setPincodeError("Invalid pincode or no data found.");
          setNewAddress((prev) => ({
            ...prev,
            city: "",
            district: "",
            state: "",
            country: "",
          }));
        }
      } catch (error) {
        console.error("Error fetching pincode data:", error);
        setPincodeError("Error fetching pincode data. Please try again.");
        setNewAddress((prev) => ({
          ...prev,
          city: "",
          district: "",
          state: "",
          country: "",
        }));
      }
    } else if (pincode.length > 0 && pincode.length !== 6) {
      setPincodeError("Pincode must be 6 digits.");
    } else {
      setPincodeError(null);
      setNewAddress((prev) => ({
        ...prev,
        city: "",
        district: "",
        state: "",
        country: "",
      }));
    }
  };

  const handleMobileNumberChange = (e) => {
    const mobile_number = e.target.value;
    setNewAddress({ ...newAddress, mobile_number });
  };

  const handleSaveAddress = async () => {
    if (
      !newAddress.full_name ||
      !newAddress.mobile_number ||
      !newAddress.address1 ||
      !newAddress.pincode ||
      !newAddress.city ||
      !newAddress.district ||
      !newAddress.state ||
      !newAddress.country
    ) {
      toast.error("Please fill all required fields.", {
        style: { borderRadius: "10px", background: "#333", color: "#fff" },
      });
      return;
    }
    if (!/^\d{10}$/.test(newAddress.mobile_number)) {
      toast.error("Please enter a valid 10-digit mobile number.", {
        style: { borderRadius: "10px", background: "#333", color: "#fff" },
      });
      return;
    }
    if (pincodeError) {
      toast.error("Please enter a valid pincode.", {
        style: { borderRadius: "10px", background: "#333", color: "#fff" },
      });
      return;
    }

    const customerId = localStorage.getItem("customer_id");
    if (!customerId) {
      toast.error("Customer ID not found. Please log in again.", {
        style: { borderRadius: "10px", background: "#333", color: "#fff" },
      });
      return;
    }

    const payload = {
      customer_id: customerId,
      country: newAddress.country,
      care_of: newAddress.care_of || null,
      full_name: newAddress.full_name,
      mobile_no: parseInt(newAddress.mobile_number),
      pincode: parseInt(newAddress.pincode),
      address1: newAddress.address1,
      address2: newAddress.address2 || "",
      landmark: newAddress.landmark || "",
      town: newAddress.city,
      district: newAddress.district,
      state: newAddress.state,
    };

    try {
      setLoading(true);
      if (editAddress) {
        await axios.put(
          `${process.env.REACT_APP_API_BASE_URL}/address/?address_id=${editAddress.address_id}`,
          payload
        );
        toast.success("Address updated successfully", {
          style: { borderRadius: "10px", background: "#333", color: "#fff" },
        });
      } else {
        await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/address/`,
          payload
        );
        toast.success("Address added successfully", {
          style: { borderRadius: "10px", background: "#333", color: "#fff" },
        });
      }

      await fetchAddresses();

      setOpenAdd(false);
      setEditAddress(null);
      setNewAddress({
        full_name: "",
        mobile_number: "",
        care_of: "",
        address1: "",
        address2: "",
        landmark: "",
        pincode: "",
        city: "",
        district: "",
        state: "",
        country: "",
      });
      setPincodeError(null);
    } catch (error) {
      console.error("Error saving/updating address:", error);
      toast.error(
        `Failed to ${editAddress ? "update" : "save"} address. Please try again.`,
        {
          style: { borderRadius: "10px", background: "#333", color: "#fff" },
        }
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteAddress = async (address_id) => {
    if (!window.confirm("Are you sure you want to delete this address?"))
      return;

    try {
      setLoading(true);
      await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/address/?customer_id=${customerId}&address_id=${address_id}`
      );
      setUserAddressData((prev) =>
        prev.filter((addr) => addr.address_id !== address_id)
      );
      if (deleveryAddress.address_id === address_id) {
        const newDefault =
          userAddressData.find(
            (addr) => addr.default && addr.address_id !== address_id
          ) || userAddressData.find((addr) => addr.address_id !== address_id);
        setDeliveryAddress(newDefault || {});
      }
      toast.success("Address deleted successfully", {
        style: { borderRadius: "10px", background: "#333", color: "#fff" },
      });
    } catch (error) {
      console.error("Error deleting address:", error);
      toast.error("Failed to delete address. Please try again.", {
        style: { borderRadius: "10px", background: "#333", color: "#fff" },
      });
    } finally {
      setLoading(false);
    }
  };

  const handleEditAddress = (address) => {
    setNewAddress({
      full_name: address.full_name,
      mobile_number: address.mobile_no.toString(),
      care_of: address.care_of || "",
      address1: address.address1,
      address2: address.address2 || "",
      landmark: address.landmark || "",
      pincode: address.pincode.toString(),
      city: address.town,
      district: address.district,
      state: address.state,
      country: address.country,
    });
    setEditAddress(address);
    setOpenAdd(true);
    setPincodeError(null);
  };

  const isAllRegularProducts = originalSelectedItems.every(
    (item) => item.is_product === true || item.is_product === "true"
  );

  // === UPDATED: onCheckOut with availability check first ===
  const onCheckOut = async (e) => {
    e.preventDefault();
    setLoading(true);

    // 1. Check product availability
    const isAvailable = await checkAvailability();
    if (!isAvailable) {
      setLoading(false);
      return;
    }

    // 2. Proceed with order creation
    try {
      const sku_codes = originalSelectedItems.map((item) => {
        const isRegular =
          item.is_product === true || item.is_product === "true";

        return {
          is_item: item.is_item,
          sku_code: isRegular
            ? item.variant?.sizes?.[0]?.sku || ""
            : item.sku_code || item.sku || "",
          quantity: item.quantity || 1,
          price: isRegular
            ? item.variant?.sizes?.[0]?.price?.discounted ||
              item.variant?.sizes?.[0]?.price?.mrp ||
              0
            : 0,
          custom_size: isRegular ? "" : item.custom_size || "",
          custom_text: isRegular ? "" : item.custom_text || "",
          logos: isRegular ? [] : item.logos || [],
          reference_image: isRegular ? "" : item.reference_image || "",
        };
      });

      const payload = {
        customer_id: parseInt(userData.customer_id),
        shipping_address: deleveryAddress.address_id,
        total_amount: appliedCouponData?.applicable
          ? appliedCouponData.final_order_value
          : orderItem.total_amount,
        payment_method: selectedPaymentMethod.toLowerCase(),
        sku_codes: sku_codes,
        coupon_id: appliedCouponData?.coupon_id || null,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/create-order/`,
        payload
      );

      if (response.data && response.data.order_id) {
        localStorage.setItem("orderId", response.data.order_id);
        toast.success("Order placed successfully!", {
          style: { borderRadius: "10px", background: "#333", color: "#fff" },
        });

        if (selectedPaymentMethod.toLowerCase() === "phonepe") {
          if (response.data.payment_link) {
            window.location.href = response.data.payment_link;
          } else {
            throw new Error("Payment link not found in response");
          }
        } else {
          navigate("/order-verification-success", {
            state: {
              orderData: response.data,
              is_product: isAllRegularProducts,
            },
          });
        }
      } else {
        throw new Error("Order creation failed");
      }
    } catch (error) {
      console.error("Error creating order:", error);
      toast.error("Failed to place order. Please try again.", {
        style: { borderRadius: "10px", background: "#333", color: "#fff" },
      });
    } finally {
      setLoading(false);
    }
  };

  const renderVariants = (variants) => {
    if (!variants) return "";
    return variants.map((variant) => variant.code).join(", ");
  };

  const onClose = () => {
    setOpenAdd(false);
    setEditAddress(null);
    setNewAddress({
      full_name: "",
      mobile_number: "",
      care_of: "",
      address1: "",
      address2: "",
      landmark: "",
      pincode: "",
      city: "",
      district: "",
      state: "",
      country: "",
    });
    setPincodeError(null);
  };

  const checkCouponApplicability = async () => {
    if (!coupon) {
      alert("Please enter a coupon code.");
      return;
    }

    if (
      !orderItem ||
      !orderItem.items_code ||
      orderItem.items_code.length === 0
    ) {
      alert("No products in the order. Cannot apply a coupon.");
      return;
    }

    setIsApplyCouponLoading(true);
    setIsApplyCouponError(false);

    try {
      setTimeout(() => {
        if (coupon.toUpperCase() === "SAVE10") {
          setAppliedCouponData({
            applicable: true,
            coupon_id: "CPN123",
            discount: Math.round(orderItem.total_amount * 0.1),
            final_order_value: Math.round(orderItem.total_amount * 0.9),
            message: "Coupon applied successfully!",
          });
        } else {
          setAppliedCouponData({
            applicable: false,
            message: "Invalid coupon code",
          });
        }
        setIsApplyCouponLoading(false);
      }, 1000);
    } catch (error) {
      console.error("Error checking coupon applicability:", error);
      setIsApplyCouponLoading(false);
      setIsApplyCouponError(true);
      alert("Error applying coupon.");
    }
  };

  const hasCustomizedProducts = useMemo(() => {
    return checkOutItems.some((item) => item.isCustomized);
  }, [checkOutItems]);

  const allProductsAvailable = useMemo(() => {
    if (
      !Array.isArray(pincodeAvailability) ||
      pincodeAvailability.length === 0
    ) {
      return false;
    }
    return pincodeAvailability.every((avail) => avail.available);
  }, [pincodeAvailability]);

  const renderProductItem = (item, index) => {
    const isCartItem = locationType === "cart";
    const product = isCartItem ? item.item : item;
    const isCustomized = item.isCustomized || false;

    const productAvailability = Array.isArray(pincodeAvailability)
      ? pincodeAvailability.find(
          (avail) => avail.product_id === product.product_id?.toString()
        )
      : null;

    return (
      <div
        key={index}
        className="mt-4 rounded-md shadow flex gap-4 flex-col dark:shadow-gray-800"
      >
        <div className="p-3 h-auto flex flex-col justify-between items-center">
          <div className="h-auto w-full flex gap-2">
            <img
              className="h-24 w-24 object-contain"
              src={product.photos?.[0]?.photo_url || fallbackImage}
              alt=""
            />
            <div className="flex flex-col gap-1">
              <p className="text-sm">
                {isCustomized ? "Customized Product" : product.product_name}
              </p>

              {isCustomized ? (
                <div className="text-xs text-gray-600">
                  <p>Customizations:</p>
                  <p>• Text: {item.customizations?.customText || "None"}</p>
                  <p>
                    • Color: {item.customizations?.selectedColor || "Default"}
                  </p>
                  <p>• Size: {item.customizations?.selectedSize || "N/A"}</p>
                  <p>• Logos: {item.customizations?.logos?.length || 0}</p>
                </div>
              ) : (
                <p className="text-xs">{renderVariants(product?.variants)}</p>
              )}

              <p className="text-sm font-bold">
                ₹ {product.selling_price || product.price || 999}
                {"  "}
                {product.mrp && (
                  <span className="inline-block">
                    <del className="text-slate-400">₹{product.mrp}</del>
                  </span>
                )}
              </p>
              <p className="text-xs">
                Quantity: {isCartItem ? item.quantity : count || item.quantity}
              </p>

              <div className="flex items-center gap-2 mt-1">
                {productAvailability && (
                  <>
                    {productAvailability.available ? (
                      <CheckCircle2 />
                    ) : (
                      <AlertCircle />
                    )}
                    <p
                      className={`text-xs ${
                        productAvailability.available
                          ? "text-green-600"
                          : "text-red-600"
                      }`}
                    >
                      {productAvailability.message}
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50">
          <div className="spinner border-t-4 border-green-500 border-solid rounded-full w-16 h-16 animate-spin"></div>
        </div>
      )}
      <Navbar navClass="defaultscroll is-sticky" navlight={true} />
      <section className="relative table w-full items-center py-36 bg-[url('../../assets/images/hero/pages.jpg')] bg-top bg-no-repeat bg-cover">
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/60 via-slate-900/80 to-slate-900"></div>
        <div className="container relative mx-auto px-4">
          <div className="grid grid-cols-1 pb-8 text-center mt-10">
            <h3 className="mb-3 text-2xl sm:text-3xl md:text-4xl font-semibold text-white">
              Checkout
            </h3>
            <p className="text-slate-400 text-base sm:text-lg max-w-xl mx-auto">
              Complete your purchase by providing payment details and confirming
              your delivery address.
            </p>
          </div>
        </div>
        <div className="absolute text-center z-10 bottom-5 start-0 end-0 mx-3">
          <ul className="tracking-[0.5px] mb-0 inline-block">
            <li className="inline-block uppercase text-[11px] sm:text-[13px] font-bold duration-500 ease-in-out text-white/50 hover:text-white">
              <Link to="/">Sportyfi</Link>
            </li>
            <li className="inline-block text-base text-white/50 mx-0.5 ltr:rotate-0 rtl:rotate-180">
              <i className="mdi mdi-chevron-right"></i>
            </li>
            <li
              className="inline-block uppercase text-[11px] sm:text-[13px] font-bold duration-500 ease-in-out text-white"
              aria-current="page"
            >
              Checkout
            </li>
          </ul>
        </div>
      </section>

      <section className="relative md:py-24 py-16">
        <div className="container relative">
          <div className="grid lg:grid-cols-12 md:grid-cols-2 grid-cols-1 gap-6">
            <div className="lg:col-span-8">
              <div className="p-6 rounded-md shadow dark:shadow-gray-800">
                <h3 className="text-xl leading-normal font-semibold">
                  Billing address
                </h3>
                {userAddressData && userAddressData.length > 0 && !change ? (
                  <div className="w-full text-black shadow-md rounded-lg overflow-hidden">
                    <div className="flex justify-between items-center p-4 pb-0">
                      <p className="font-semibold">{`Delivering to ${deleveryAddress?.full_name}`}</p>
                      <button
                        className="text-sm underline hover:text-green-500 transition-opacity"
                        onClick={() => setChange(!change)}
                      >
                        Change
                      </button>
                    </div>
                    <div className="px-4 pb-4">
                      <p className="text-sm">
                        {`${deleveryAddress?.address1}, ${
                          deleveryAddress?.address2
                            ? deleveryAddress.address2 + ", "
                            : ""
                        }${
                          deleveryAddress?.landmark
                            ? deleveryAddress.landmark + ", "
                            : ""
                        }${deleveryAddress?.town}, ${
                          deleveryAddress?.district
                        }, ${deleveryAddress?.state}, ${
                          deleveryAddress?.pincode
                        }, ${deleveryAddress?.country}${
                          deleveryAddress?.care_of
                            ? ", Care of: " + deleveryAddress.care_of
                            : ""
                        }`}
                      </p>
                      <p className="text-sm">
                        Mobile: {deleveryAddress?.mobile_no}
                      </p>
                    </div>
                  </div>
                ) : !change ? (
                  <div>
                    {addressFetchError ? (
                      <p className="text-red-500 text-sm">
                        {addressFetchError}
                      </p>
                    ) : (
                      "No address available"
                    )}
                  </div>
                ) : null}

                {change && (
                  <div className="mt-4">
                    <h4 className="font-medium mb-2">
                      Select Delivery Address
                    </h4>
                    {addressFetchError ? (
                      <p className="text-red-500 text-sm">
                        {addressFetchError}
                      </p>
                    ) : userAddressData.length === 0 ? (
                      <p className="text-sm text-gray-600">
                        No addresses available
                      </p>
                    ) : (
                      <div className="space-y-3">
                        {userAddressData.map((address) => (
                          <div
                            key={address.address_id}
                            className={`p-3 border rounded-lg flex justify-between items-start ${
                              deleveryAddress.address_id === address.address_id
                                ? "border-green-500 bg-green-50"
                                : "border-gray-200"
                            }`}
                          >
                            <div
                              className="cursor-pointer flex-1"
                              onClick={() => {
                                setDeliveryAddress(address);
                                setChange(false);
                              }}
                            >
                              <p className="font-medium">{address.full_name}</p>
                              <p className="text-sm text-gray-600">
                                {`${address.address1}, ${
                                  address.address2
                                    ? address.address2 + ", "
                                    : ""
                                }${
                                  address.landmark
                                    ? address.landmark + ", "
                                    : ""
                                }${address.town}, ${address.district}, ${
                                  address.state
                                }, ${address.pincode}, ${address.country}${
                                  address.care_of
                                    ? ", Care of: " + address.care_of
                                    : ""
                                }`}
                              </p>
                              <p className="text-sm text-gray-600">
                                Mobile: {address.mobile_no}
                              </p>
                            </div>
                            <div className="flex flex-col gap-2 ml-2">
                              <button
                                className="text-sm"
                                onClick={() => handleEditAddress(address)}
                              >
                                <Edit />
                              </button>
                              <button
                                className="text-sm"
                                onClick={() =>
                                  handleDeleteAddress(address.address_id)
                                }
                              >
                                <Trash2 />
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                <button
                  className="text-blue-600 text-sm mt-2 cursor-pointer flex gap-1 items-center hover:text-green-500"
                  onClick={() => setOpenAdd(!openAdd)}
                >
                  <FiPlus className="h-4 w-4" /> Add a new delivery address
                </button>

                {openAdd && (
                  <div className="mt-4 p-4 border rounded-lg">
                    <h4 className="font-medium mb-3">
                      {editAddress ? "Edit Address" : "Add New Address"}
                    </h4>
                    <div className="space-y-3">
                      <input
                        type="text"
                        placeholder="Full Name"
                        className="w-full p-2 border rounded"
                        value={newAddress.full_name}
                        onChange={(e) =>
                          setNewAddress({
                            ...newAddress,
                            full_name: e.target.value,
                          })
                        }
                      />
                      <div>
                        <input
                          type="text"
                          placeholder="Mobile Number"
                          className={`w-full p-2 border rounded ${
                            newAddress.mobile_number &&
                            !/^\d{10}$/.test(newAddress.mobile_number)
                              ? "border-red-500"
                              : ""
                          }`}
                          value={newAddress.mobile_number}
                          onChange={handleMobileNumberChange}
                        />
                        {newAddress.mobile_number &&
                          !/^\d{10}$/.test(newAddress.mobile_number) && (
                            <p className="text-red-500 text-xs mt-1">
                              Mobile number must be 10 digits.
                            </p>
                          )}
                      </div>
                      <input
                        type="text"
                        placeholder="Care Of (Optional)"
                        className="w-full p-2 border rounded"
                        value={newAddress.care_of}
                        onChange={(e) =>
                          setNewAddress({
                            ...newAddress,
                            care_of: e.target.value,
                          })
                        }
                      />
                      <input
                        type="text"
                        placeholder="Address Line 1"
                        className="w-full p-2 border rounded"
                        value={newAddress.address1}
                        onChange={(e) =>
                          setNewAddress({
                            ...newAddress,
                            address1: e.target.value,
                          })
                        }
                      />
                      <input
                        type="text"
                        placeholder="Address Line 2"
                        className="w-full p-2 border rounded"
                        value={newAddress.address2}
                        onChange={(e) =>
                          setNewAddress({
                            ...newAddress,
                            address2: e.target.value,
                          })
                        }
                      />
                      <input
                        type="text"
                        placeholder="Landmark"
                        className="w-full p-2 border rounded"
                        value={newAddress.landmark}
                        onChange={(e) =>
                          setNewAddress({
                            ...newAddress,
                            landmark: e.target.value,
                          })
                        }
                      />
                      <div className="grid grid-cols-2 gap-3">
                        <div>
                          <input
                            type="text"
                            placeholder="Pincode"
                            className={`p-2 border rounded w-full ${
                              pincodeError ? "border-red-500" : ""
                            }`}
                            value={newAddress.pincode}
                            onChange={handlePincodeChange}
                          />
                          {pincodeError && (
                            <p className="text-red-500 text-xs mt-1">
                              {pincodeError}
                            </p>
                          )}
                        </div>
                        <input
                          type="text"
                          placeholder="City"
                          className="p-2 border rounded"
                          value={newAddress.city}
                          onChange={(e) =>
                            setNewAddress({
                              ...newAddress,
                              city: e.target.value,
                            })
                          }
                          disabled={newAddress.city && !pincodeError}
                        />
                      </div>
                      <div className="grid grid-cols-2 gap-3">
                        <input
                          type="text"
                          placeholder="District"
                          className="p-2 border rounded"
                          value={newAddress.district}
                          onChange={(e) =>
                            setNewAddress({
                              ...newAddress,
                              district: e.target.value,
                            })
                          }
                          disabled={newAddress.district && !pincodeError}
                        />
                        <input
                          type="text"
                          placeholder="State"
                          className="p-2 border rounded"
                          value={newAddress.state}
                          onChange={(e) =>
                            setNewAddress({
                              ...newAddress,
                              state: e.target.value,
                            })
                          }
                          disabled={newAddress.state && !pincodeError}
                        />
                      </div>
                      <input
                        type="text"
                        placeholder="Country"
                        className="p-2 border rounded"
                        value={newAddress.country}
                        onChange={(e) =>
                          setNewAddress({
                            ...newAddress,
                            country: e.target.value,
                          })
                        }
                        disabled={newAddress.country && !pincodeError}
                      />
                      <div className="flex justify-end gap-2">
                        <button
                          className="px-4 py-2 border rounded text-gray-600"
                          onClick={onClose}
                        >
                          Cancel
                        </button>
                        <button
                          className="px-4 py-2 bg-green-500 text-white rounded"
                          onClick={handleSaveAddress}
                        >
                          {editAddress ? "Update Address" : "Save Address"}
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                <h3 className="text-xl leading-normal font-semibold mt-6">
                  Payment Method
                </h3>
                <div className="mt-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div
                      className={`p-4 border rounded-lg cursor-pointer transition-all duration-300 ${
                        selectedPaymentMethod === "COD"
                          ? "border-green-500 bg-green-50 shadow-md"
                          : "border-gray-200 hover:border-green-300 hover:shadow-sm"
                      }`}
                      onClick={() => setSelectedPaymentMethod("COD")}
                    >
                      <div className="flex items-center">
                        <div className="flex-shrink-0">
                          <CODIcon />
                        </div>
                        <div className="ml-4">
                          <h4 className="text-base font-medium text-gray-900">
                            Cash on Delivery
                          </h4>
                          <p className="text-sm text-gray-500">
                            Pay when you receive your order
                          </p>
                        </div>
                        <div className="ml-auto">
                          {selectedPaymentMethod === "COD" && (
                            <div className="h-5 w-5 rounded-full bg-green-500 flex items-center justify-center">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-3 w-3 text-white"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      className={`p-4 border rounded-lg cursor-pointer transition-all duration-300 ${
                        hasCustomizedProducts
                          ? "opacity-50 cursor-not-allowed"
                          : selectedPaymentMethod === "PhonePe"
                          ? "border-green-500 bg-green-50 shadow-md"
                          : "border-gray-200 hover:border-green-300 hover:shadow-sm"
                      }`}
                      onClick={() =>
                        !hasCustomizedProducts && setSelectedPaymentMethod("PhonePe")
                      }
                    >
                      <div className="flex items-center">
                        <div className="flex-shrink-0">
                          <PhonePeIcon />
                        </div>
                        <div className="ml-4">
                          <h4 className="text-base font-medium text-gray-900">
                            Online/UPI
                          </h4>
                          <p className="text-sm text-gray-500">
                            Pay using UPI, Cards, Netbanking etc.
                          </p>
                          {hasCustomizedProducts && (
                            <p className="text-xs text-red-500 mt-1">
                              Not available for customized products
                            </p>
                          )}
                        </div>
                        <div className="ml-auto">
                          {selectedPaymentMethod === "PhonePe" && (
                            <div className="h-5 w-5 rounded-full bg-green-500 flex items-center justify-center">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-3 w-3 text-white"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-6">
                  <input
                    type="button"
                    className={`py-3 px-5 inline-block tracking-wide align-middle duration-500 text-base text-center rounded-md w-full font-semibold 
                      ${
                        allProductsAvailable
                          ? "bg-green-500 text-white hover:bg-green-600 cursor-pointer"
                          : "bg-gray-300 text-gray-500 cursor-not-allowed"
                      }`}
                    value="Place your Order"
                    onClick={allProductsAvailable ? onCheckOut : undefined}
                    disabled={!allProductsAvailable}
                  />
                </div>
              </div>
            </div>

            <div className="lg:col-span-4">
              <div className="p-6 rounded-md shadow dark:shadow-gray-800">
                <div className="flex justify-between items-center">
                  <h5 className="text-lg font-semibold">Order Summary</h5>
                  <span className="bg-green-500 flex justify-center items-center text-white text-[10px] font-bold px-2.5 py-0.5 rounded-full h-5">
                    {checkOutItems.length}
                  </span>
                </div>

                {checkOutItems.map((item, index) =>
                  renderProductItem(item, index)
                )}

                <div className="mt-4 space-y-2">
                  <div className="flex justify-between">
                    <span className="text-slate-400">Subtotal:</span>
                    <span className="font-semibold">
                      ₹ {orderItem?.total_amount || 0}
                    </span>
                  </div>

                  {appliedCouponData?.applicable && (
                    <div className="flex justify-between text-green-600">
                      <span>Discount:</span>
                      <span>- ₹ {appliedCouponData.discount}</span>
                    </div>
                  )}

                  <div className="flex justify-between border-t pt-2">
                    <span className="font-semibold">Total Amount:</span>
                    <span className="font-semibold">
                      ₹{" "}
                      {appliedCouponData?.applicable
                        ? appliedCouponData.final_order_value
                        : orderItem?.total_amount || 0}
                    </span>
                  </div>
                </div>

                <div className="subcribe-form mt-6">
                  <div className="relative max-w-xl">
                    <input
                      type="text"
                      onChange={(e) => setCoupon(e.target.value)}
                      value={coupon}
                      name="coupon"
                      className="py-4 pe-40 ps-6 w-full h-[50px] outline-none text-black dark:text-white rounded-full bg-white dark:bg-slate-900 shadow dark:shadow-gray-800"
                      placeholder="Promo code"
                    />
                    <button
                      type="submit"
                      onClick={checkCouponApplicability}
                      className="py-2 px-5 inline-block font-semibold tracking-wide align-middle duration-500 text-base text-center absolute top-[2px] end-[3px] h-[46px] bg-green-500 text-white rounded-full hover:bg-green-600"
                      disabled={isApplyCouponLoading}
                    >
                      {isApplyCouponLoading ? "Applying..." : "Redeem"}
                    </button>
                  </div>
                  {isApplyCouponError && (
                    <p className="text-red-500 text-sm mt-2">
                      Error applying coupon
                    </p>
                  )}
                  {appliedCouponData?.applicable && (
                    <p className="text-green-600 text-xs mt-2">
                      {appliedCouponData.message}
                    </p>
                  )}
                  {!appliedCouponData?.applicable &&
                    appliedCouponData?.message && (
                      <p className="text-red-600 text-xs mt-2">
                        {appliedCouponData.message}
                      </p>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <ScrollToTop />
    </>
  );
}